//Menu
export const states = [
    {value: '', label: '* Selecciona estado'},
    {value:'AGU', label: 'Aguascalientes'},
    {value:'BCN', label: 'Baja California'},
    {value:'BCS', label: 'Baja California Sur'},
    {value:'CAM', label: 'Campeche'},
    {value:'CHP', label: 'Chiapas'},
    {value:'CHH', label: 'Chihuahua'},
    {value:'CDMX', label: 'Ciudad de México'},
    {value:'COA', label: 'Coahuila'},
    {value:'COL', label: 'Colima'},
    {value:'DUR', label: 'Durango'},
    {value:'GUA', label: 'Guanajuato'},
    {value:'GRO', label: 'Guerrero'},
    {value:'HID', label: 'Hidalgo'},
    {value:'JAL', label: 'Jalisco'},
    {value:'MEX', label: 'México'},
    {value:'MIC', label: 'Michoacán'},
    {value:'MOR', label: 'Morelos'},
    {value:'NAY', label: 'Nayarit'},
    {value:'NLE', label: 'Nuevo León'},
    {value:'OAX', label: 'Oaxaca'},
    {value:'PUE', label: 'Puebla'},
    {value:'QUE', label: 'Querétaro'},
    {value:'ROO', label: 'Quintana Roo'},
    {value:'SLP', label: 'San Luis Potosí'},
    {value:'SIN', label: 'Sinaloa'},
    {value:'SON', label: 'Sonora'},
    {value:'TAB', label: 'Tabasco'},
    {value:'TAM', label: 'Tamaulipas'},
    {value:'TLA', label: 'Tlaxcala'},
    {value:'VER', label: 'Veracruz'},
    {value:'YUC', label: 'Yucatán'},
    {value:'ZAC', label: 'Zacatecas'},
];

export const municipality = [
    {value : '01', municipal :
        [
            {
                "clave": "1",
                "nombre": "Aguascalientes"
            },
            {
                "clave": "2",
                "nombre": "Asientos"
            },
            {
                "clave": "3",
                "nombre": "Calvillo"
            },
            {
                "clave": "4",
                "nombre": "Cosío"
            },
            {
                "clave": "5",
                "nombre": "Jesús María"
            },
            {
                "clave": "6",
                "nombre": "Pabellón de Arteaga"
            },
            {
                "clave": "7",
                "nombre": "Rincón de Romos"
            },
            {
                "clave": "8",
                "nombre": "San José de Gracia"
            },
            {
                "clave": "9",
                "nombre": "Tepezalá"
            },
            {
                "clave": "10",
                "nombre": "El Llano"
            },
            {
                "clave": "11",
                "nombre": "San Francisco de los Romo"
            }
        ]
    },
    {value : '02', municipal :
        {}
    },
    {value : '03', municipal :
        {}
    },
    {value : '04', municipal :
        {}
    },
    {value : '05', municipal :
        {}
    },
    {value : '06', municipal :
        {}
    },
    {value : '07', municipal :
        {}
    },
    {value : '08', municipal :
        {}
    },
    {value : '09', municipal :
        {}
    },
    {value : '10', municipal :
        {}
    },
    {value : '11', municipal :
        {}
    },
    {value : '12', municipal :
        {}
    },
    {value : '13', municipal :
        {}
    },
    {value : '14', municipal :
        {}
    },
    {value : '15', municipal :
        {}
    },
    {value : '16', municipal :
        {}
    },
    {value : '17', municipal :
        {}
    },
    {value : '18', municipal :
        {}
    },
    {value : '19', municipal :
        {}
    },
    {value : '20', municipal :
        {}
    },
    {value : '21', municipal :
        {}
    },
    {value : '22', municipal :
        {}
    },
    {value : '23', municipal :
        {}
    },
    {value : '24', municipal :
        {}
    },
    {value : '25', municipal :
        {}
    },
    {value : '26', municipal :
        {}
    },
    {value : '27', municipal :
        {}
    },
    {value : '28', municipal :
        {}
    },
    {value : '29', municipal :
        {}
    },
    {value : '30', municipal :
        {}
    },
    {value : '31', municipal :
        {}
    },
    {value : '32', municipal :
        {}
    }

];

export const days = [
    {value: '', label: 'Selecciona día'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '05', label: '05'},
    {value: '06', label: '06'},
    {value: '07', label: '07'},
    {value: '08', label: '08'},
    {value: '09', label: '09'},
    {value: '10', label: '10'},
    {value: '11', label: '11'},
    {value: '12', label: '12'},
    {value: '13', label: '13'},
    {value: '14', label: '14'},
    {value: '15', label: '15'},
    {value: '16', label: '16'},
    {value: '17', label: '17'},
    {value: '18', label: '18'},
    {value: '19', label: '19'},
    {value: '20', label: '20'},
    {value: '21', label: '21'},
    {value: '22', label: '22'},
    {value: '23', label: '23'},
    {value: '24', label: '24'},
    {value: '25', label: '25'},
    {value: '26', label: '26'},
    {value: '27', label: '27'},
    {value: '28', label: '28'},
    {value: '29', label: '29'},
    {value: '30', label: '30'},
    {value: '31', label: '31'}
  ];

  export const months = [
    {value: '', label: 'Selecciona mes'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '05', label: '05'},
    {value: '06', label: '06'},
    {value: '07', label: '07'},
    {value: '08', label: '08'},
    {value: '09', label: '09'},
    {value: '10', label: '10'},
    {value: '11', label: '11'},
    {value: '12', label: '12'},
  ];

  export const years = [
    {value: '', label: 'Selecciona año'},
    {value: '2022', label: '2022'},
    {value: '2021', label: '2021'},
    {value: '2020', label: '2020'},
    {value: '2019', label: '2019'},
    {value: '2018', label: '2018'},
    {value: '2017', label: '2017'},
    {value: '2016', label: '2016'},
    {value: '2015', label: '2015'},
    {value: '2014', label: '2014'},
    {value: '2013', label: '2013'},
    {value: '2012', label: '2012'},
    {value: '2011', label: '2011'},
    {value: '2010', label: '2010'},
    {value: '2009', label: '2009'},
    {value: '2008', label: '2008'},
    {value: '2007', label: '2007'},
    {value: '2006', label: '2006'},
    {value: '2005', label: '2005'},
    {value: '2004', label: '2004'},
    {value: '2003', label: '2003'},
    {value: '2002', label: '2002'},
    {value: '2001', label: '2001'},
    {value: '2000', label: '2000'},
    {value: '1999', label: '1999'},
    {value: '1998', label: '1998'},
    {value: '1997', label: '1997'},
    {value: '1996', label: '1996'},
    {value: '1995', label: '1995'},
    {value: '1994', label: '1994'},
    {value: '1993', label: '1993'},
    {value: '1992', label: '1992'},
    {value: '1991', label: '1991'},
    {value: '1990', label: '1990'},
    {value: '1989', label: '1989'},
    {value: '1988', label: '1988'},
    {value: '1987', label: '1987'},
    {value: '1986', label: '1986'},
    {value: '1985', label: '1985'},
    {value: '1984', label: '1984'},
    {value: '1983', label: '1983'},
    {value: '1982', label: '1982'},
    {value: '1981', label: '1981'},
    {value: '1980', label: '1980'},
    {value: '1979', label: '1979'},
    {value: '1978', label: '1978'},
    {value: '1977', label: '1977'},
    {value: '1976', label: '1976'},
    {value: '1975', label: '1975'},
    {value: '1974', label: '1974'},
    {value: '1973', label: '1973'},
    {value: '1972', label: '1972'},
    {value: '1971', label: '1971'},
    {value: '1970', label: '1970'},
    {value: '1969', label: '1969'},
    {value: '1968', label: '1968'},
    {value: '1967', label: '1967'},
    {value: '1966', label: '1966'},
    {value: '1965', label: '1965'},
    {value: '1964', label: '1964'},
    {value: '1963', label: '1963'},
    {value: '1962', label: '1962'},
    {value: '1961', label: '1961'},
    {value: '1960', label: '1960'}
  ];

  export const yearsCard = [
    {value: '', label: 'Selecciona año'},
    {value: '01', label: '2020'},
    {value: '02', label: '2021'},
    {value: '03', label: '2022'},
    {value: '04', label: '2023'},
    {value: '05', label: '2024'},
    {value: '06', label: '2025'},
    {value: '07', label: '2026'},
    {value: '08', label: '2027'},
    {value: '09', label: '2028'},
    {value: '10', label: '2029'},
    {value: '10', label: '2030'},
    {value: '10', label: '2031'},
    {value: '10', label: '2032'},
    {value: '10', label: '2033'},
    {value: '10', label: '2034'},
  ];

  export const maritals = [
    {value: '', label: 'Selecciona estado civil',},
    {value: 'S', label: 'Soltero'},
    {value: 'C', label: 'Casado'},
    {value: 'D', label: 'Divorciado'},
    {value: 'W', label: 'Vuido'},
    {value: 'O', label: 'Otro'}
  ];

  export const genders = [
    {value: '', label: 'Selecciona género',},
    {value: 'M', label: 'Hombre'},
    {value: 'F', label: 'Mujer'}
  ];
